import { ISetSubscriptionsFrequencyParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class SetSubscriptionsFrequencyRequest extends Request<ISetSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSubscriptionsFrequencyParams) {
        super('setSubscriptionsSchedule', params);
    }
}
